declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

/**
 * GTM data layer: user finished get-started (profile saved, internal user id, not email).
 * Configure a Custom Event trigger on `account_registration` in GTM.
 *
 * Pushes to `window.dataLayer` directly so the event is queued even if it runs
 * before/without `react-gtm-module`’s helper (GTM processes the queue on load).
 */
export function pushAccountRegistrationDataLayer(params: { user_id: string; uid?: string }): void {
    if (typeof window === 'undefined') {
        return;
    }
    const payload: Record<string, unknown> = {
        event: 'account_registration',
        user_id: params.user_id,
    };
    if (params.uid) {
        payload.uid = params.uid;
    }
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push(payload);
}
